import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bb58f49c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bb58f49c&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=bb58f49c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58f49c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb58f49c')) {
      api.createRecord('bb58f49c', component.options)
    } else {
      api.reload('bb58f49c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bb58f49c&scoped=true", function () {
      api.rerender('bb58f49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sysmessages/index.vue"
export default component.exports